// Centralized validation rules for Project edit flow

function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  const parts = path.split(".");
  let cur = obj;
  for (let i = 0; i < parts.length; i += 1) {
    const key = parts[i];
    if (cur == null || typeof cur !== "object") return undefined;
    cur = cur[key];
  }
  return cur;
}

export function validateProjectEditForm(current) {
  const errs = {};
  if (!current || typeof current !== "object") return errs;

  // Field label mapping
  const fieldLabels = {
    "metadata.name": "Project Name",
    "metadata.shortName": "Short Project Name",
    "objectives.contributorFacingName": "Contributor Project Name",
    "metadata.appenPartner": "Appen Partner",
    "metadata.account": "Account",
    "metadata.hireStartDate": "Hire Start Date",
    "metadata.predictedCloseDate": "Predicted Close Date",
    "metadata.projectStatus": "Project Status",
    "metadata.projectType": "Project Type",
    "metadata.projectPriority": "Project Priority",
  };

  // Required fields for edit flow
  const required = [
    "metadata.name",
    "metadata.shortName",
    "objectives.contributorFacingName",
    "metadata.appenPartner",
    "metadata.account",
    "metadata.hireStartDate",
    "metadata.predictedCloseDate",
    // "metadata.projectStatus", // OPTIONAL: Made optional for now
    "metadata.projectType",
    "metadata.projectPriority",
  ];

  required.forEach((path) => {
    const v = getByPath(current, path);
    if (v === undefined || String(v).trim() === "") {
      errs[path] = `${fieldLabels[path]}: This field is required`;
    }
  });

  // Allowed statuses
  const allowedStatuses = ["Draft", "Open", "Roster Hold", "Closed"];
  const status = getByPath(current, "metadata.projectStatus");
  if (status && !allowedStatuses.includes(String(status))) {
    errs["metadata.projectStatus"] =
      `${fieldLabels["metadata.projectStatus"]}: Invalid status`;
  }

  // Date range consistency
  const start = getByPath(current, "metadata.hireStartDate");
  const end = getByPath(current, "metadata.predictedCloseDate");
  if (start && end) {
    const sd = new Date(start);
    const ed = new Date(end);
    if (!isNaN(sd) && !isNaN(ed) && ed < sd) {
      errs["metadata.predictedCloseDate"] =
        "Close date must be on/after start date";
    }
  }

  // Account: Salesforce Id (15/18 characters)
  const account = getByPath(current, "metadata.account");
  if (account) {
    const validId = /^[A-Za-z0-9]{15,18}$/;
    if (!validId.test(String(account))) {
      errs["metadata.account"] = "Account must be a 15/18 char Salesforce Id";
    }
  }

  // Project Priority: integer >= 1
  const priority = getByPath(current, "metadata.projectPriority");
  if (priority !== undefined && priority !== "") {
    const n = Number(priority);
    if (!Number.isInteger(n) || n < 1) {
      errs["metadata.projectPriority"] = "Priority must be an integer >= 1";
    }
  }

  return errs;
}
